import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyDialogComponent } from './verify-dialog.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [VerifyDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  exports: [VerifyDialogComponent]
})
export class VerifyDialogModule { }
